"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "leggiuno": {
    "625cb0ca": [{
      "hkey": "11a2ae8c",
      "slug": "arolo",
      "name": "Arolo",
      "primary": true,
      "skipSearch": false
    }],
    "arolo-ballarate": [{
      "hkey": "11a2ae8c",
      "slug": "arolo",
      "name": "Arolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ae8400b6": [{
      "hkey": "d6d4f3cc",
      "slug": "ballarate",
      "name": "Ballarate",
      "primary": true,
      "skipSearch": false
    }],
    "marzaro": [{
      "hkey": "d6d4f3cc",
      "slug": "ballarate",
      "name": "Ballarate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5ee77b92": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "skipSearch": false
    }],
    "casa-motta": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c61704c6": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "skipSearch": false
    }],
    "ghirate": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fc2ae495": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "skipSearch": false
    }],
    "il-moro": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bdfecc6a": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "skipSearch": false
    }],
    "la-gesiola": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "be1eeb96": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "skipSearch": false
    }],
    "roncaccio": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6aaaaecd": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "skipSearch": false
    }],
    "rozzoni": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "67a62def": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "skipSearch": false
    }],
    "santa-caterina-del-sasso": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7abe28d5": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "c0141061",
      "slug": "leggiuno",
      "name": "Leggiuno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;